export default { sha: '9ec88e413e0ea35b41c1170b82834331accc4c52', buildNumber: 'undefined' }
